import React from "react";
import Swal from "sweetalert2";
import { baseURL } from "../../components/BaseURL";

export default function SelectCity({
  areas,
  setAreas,
  setValue,
  selectedArea,
  selectedCityParam,
  setSelectedArea,
}) {
  let hasArea = false;
  const [showAreas, setShowAreas] = React.useState(false);
  const [selectedCity, setSelectedCity] = React.useState(null);
  const [areaName, setAreaName] = React.useState("");
  const [showInputArea, setShowInputArea] = React.useState(false);
  const [userLocation, setUserLocation] = React.useState(null);

  const getUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        //console.log(position);
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        //console.log(lat, lng);
        const userLocation = { lat, lng };
        setUserLocation(userLocation);
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  React.useEffect(() => {
    getUserLocation();
  }, []);

  React.useEffect(() => {
    if (selectedCityParam) {
      const area = areas.find(
        (area) => area.id === parseInt(selectedCityParam)
      );
      if (area) {
        setAreaName(area.name);
        setSelectedCity(area.id);
        setValue("area", area.id);
      }
    }
  }, [selectedCityParam]);

  React.useEffect(() => {
    if (areaName.length > 0) {
      setShowInputArea(true);
    } else {
      setShowInputArea(false);
    }
  }, [areaName]);

  const handleAreaName = (name, id) => {
    setAreaName(name);
    setSelectedCity(id);
    setValue("area", id);
    setShowAreas(false);
  };

  const addAreaName = () => {
    //check if area name is already exists
    let areaNameExists = false;
    areas.map((area, index) => {
      if (area.name.toLowerCase() === areaName.toLowerCase()) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Area name already exists",
        });

        setAreaName(area.name);
        setSelectedCity(area.id);
        areaNameExists = true;
      }
      return null;
    });
    if (true) {
      //userLocation
      if (!areaNameExists) {
        const data = {
          name: areaName,
          //latitude: userLocation.lat,
          //longitude: userLocation.lng,
          parent: selectedArea,
          zoom_level: 0,
          type: "city",
        };
        if (userLocation) {
          data.latitude = userLocation.lat;
          data.longitude = userLocation.lng;
        }

        const url = `${baseURL}/project-main/add-area`;
        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        };
        fetch(url, options)
          .then((res) => res.json())
          .then((data) => {
            //setShowInputArea(false);
            //setAreaName("");
            //setShowAreas(false);
            if (data.status === "success") {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "Area added successfully",
              });
              setShowInputArea(false);
              setShowAreas(false);
              // add area to areas
              setAreas([...areas, data.area]);
              setValue("area", data.area.id);
            } else if (data.message === "Area already exists") {
              alert("Area already exists");
            } else {
              alert("Something went wrong! Please try again.");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
    // else {
    //     alert("Please allow location permission");
    //     getUserLocation();
    // }
  };

  return (
    <div className="">
      <div
        onClick={() => setShowAreas(!showAreas)}
        className="select select-accent bg-[#272737]  text-white w-full border border-gray-600 "
      >
        <input
          className="placeholder:text-white bg-[#272737] outline-0 w-full border-none"
          type="text"
          placeholder="Select one"
          // onFocus={() => {
          //     if (!showAreas){
          //         setShowAreas(true);
          //     }
          // }}
          onBlur={(e) => {
            e.stopPropagation();
            if (showAreas) {
              setTimeout(() => {
                setShowAreas(false);
              }, 300);
            }
          }}
          value={areaName}
          onChange={(e) => setAreaName(e.target.value)}
        />
      </div>
      {showAreas && (
        <div className="relative">
          <div
            className="drop-shadow-lg bg-white border border-gray-500 absolute"
            style={{ top: "100%", width: "100%" }}
          >
            {showInputArea && (
              <div
                onClick={addAreaName}
                className="hover:bg-blue-500 hover:text-white px-3 text-base"
              >
                + {areaName}
              </div>
            )}

            {areas.map((area) => {
              if (area.parent === parseInt(selectedArea)) {
                hasArea = true;
                return (
                  <div
                    onClick={() => {
                      handleAreaName(area.name, area.id);
                    }}
                    className="hover:bg-blue-500 hover:text-white px-3 text-base"
                    key={area.id}
                    value={area.id}
                  >
                    {area.name}
                  </div>
                );
              }
              return null;
            })}
            {!hasArea &&
              areas.map((area) => {
                if (area.id === parseInt(selectedArea)) {
                  return (
                    <>
                      <div
                        onClick={() => {
                          handleAreaName(area.name, area.id);
                        }}
                        className="hover:bg-blue-500 hover:text-white px-3 text-base"
                        key={area.id}
                        value={area.id}
                      >
                        {area.name}
                      </div>
                    </>
                  );
                }
                return null;
              })}
          </div>
        </div>
      )}
    </div>
  );
}
